import { useMediaQuery } from '@mui/system';
import React from 'react';
import useGoodsReceivedNoteLogic from 'src/components/VehicleTrackingDetails/GoodsReceivedNotesForm/useGoodsReceivedNoteLogic';
import GoodsReceivedNoteMobile from 'src/components/VehicleTrackingDetails/GoodsReceivedNotesForm/GoodsReceivedNotesMobile';
import GoodsReceivedNotesDesktop from 'src/components/VehicleTrackingDetails/GoodsReceivedNotesForm/GoodsReceivedNotesDesktop';

export default function GoodsReceivedNotesWrapper({ toggleGrnDrawer }) {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const logic = useGoodsReceivedNoteLogic();

  return isMobile ? (
    <GoodsReceivedNoteMobile toggleGrnDrawer={toggleGrnDrawer} logic={logic} />
  ) : (
    <GoodsReceivedNotesDesktop
      toggleGrnDrawer={toggleGrnDrawer}
      logic={logic}
    />
  );
}
